import { render, staticRenderFns } from "./actionCol.vue?vue&type=template&id=bfec813c&"
import script from "./actionCol.vue?vue&type=script&lang=tsx&"
export * from "./actionCol.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports